import * as Units from '../Units';

/**
 * A model's mesh size, in the user's distance unit.
 *
 * One decimal below 10, none above. Rounding everything to integers collapses
 * the catalogue: AROME's 1.3 km reads "1 km" and the five 2.5 km AROME nests
 * all read "3 km", which undoes the point of showing the mesh at all.
 *
 * The rule lived in `ForecastModelsScreen` while `ForecastModelDetailContent`
 * used a bare `toFixed(0)`, so the same model read "1.3 km" in the list and
 * "1 km" in its own detail. It lives here so there is one answer.
 *
 * Returns null for a model with no published mesh — a blend or a proprietary
 * forecast — so the caller can drop the segment rather than print "null km".
 */
export const formatMeshSize = (
  meshSize: number | null,
  units: Units.Units,
): string | null => {
  if (meshSize === null) {
    return null;
  }
  const mesh = Units.convertDistanceToUserUnit(units, meshSize) ?? meshSize;
  const figure = mesh >= 10 ? mesh.toFixed(0) : String(Number(mesh.toFixed(1)));
  return `${figure} ${Units.getDistanceUnitLabel(units)}`;
};
